import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, retry, throwError } from 'rxjs';
import { AppService } from './app.service';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  serverUrl = environment.serverUrl;


  

  constructor(
    private http: HttpClient,
    private _app: AppService
  ) { }

  private getHttpOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    const token = sessionStorage.getItem('auth_token');
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('x-access-token', token);
    }
    return { headers, withCredentials: true };
  }

  getData(endPoint: string): any {
    const vm = this;
    setTimeout(function () { vm._app.spinnerData = true; }, 0);
    return vm.http.get(vm.serverUrl + endPoint, this.getHttpOptions()).pipe(
      retry(0),
      map(res => {
        setTimeout(function () { vm._app.spinnerData = false; }, 0);
        return res;
      }),
      catchError(err => {
        return vm.handleError(err, vm);
      }));
  }

  postData(endPoint: string, data: any): any {
    const vm = this;
    setTimeout(function () { vm._app.spinnerData = true; }, 0);
    return vm.http.post(vm.serverUrl + endPoint, data, this.getHttpOptions()).pipe(
      retry(0),
      map(res => {
        setTimeout(function () { vm._app.spinnerData = false; }, 0);
        return res;
      }),
      catchError(err => {
        return vm.handleError(err, vm);
      }));
  }

  handleError(error: HttpErrorResponse, vm: any): any {
    setTimeout(function () { vm._app.spinnerData = false; }, 0);
    const status = error.status;
    let message: string;
    if (status >= 500) {
      message = 'Server error. Please try again later.';
    } else if (status === 429) {
      message = 'Too many requests. Please try again later.';
    } else if (status === 422) {
      message = 'Validation failed. Please check your input.';
    } else if (status === 404) {
      message = 'Resource not found.';
    } else if (status === 403) {
      message = 'You do not have permission to perform this action.';
    } else if (status === 401) {
      message = 'Session expired. Please login again.';
    } else if (status === 400) {
      message = 'Invalid request. Please check your input.';
    } else {
      message = 'Something went wrong. Please try again.';
    }
    return throwError(() => ({ status, message }));
  }
}